<script>
  import {
    onMount
  } from 'svelte';
  import Message from '../components/message.svelte'
  import Playbar from '../components/playbar.svelte'
  import Timeline from '../components/timeline.svelte'
  import Settings from '../components/button-settings.svelte'
  import SettingsModal from '../components/settings-modal.svelte'
  import ResumeModal from '../components/resume-modal.svelte'
  import LocationModal from '../components/location-modal.svelte'
  import WelcomeModal from '../components/welcome-modal.svelte'
  import Loader from '../components/dark-loader.svelte'
  import {
    fade,
    fly
  } from 'svelte/transition';
  import {
    push
  } from 'svelte-spa-router'
  import L from 'leaflet'
  import '../js/stamen.js'

  export let params = {}

  //Rendering Variables
  let map
  let messageData = {}
  let geoJSONLayer
  let playerMarker
  let wayPoint
  let wayPointIcon = L.icon({
    iconUrl: 'assets/waypoint.png',
    iconSize: [50, 50], // size of the icon
    iconAnchor: [25, 46], // point of the icon which will correspond to marker's location
    popupAnchor: [0, -50] // point from which the popup should open relative to the iconAnchor
  });
  let route = null
  let triggerPoint
  let locationTrigger = false

  //Audio Variables
  let audioContext
  let audioPlaying = false;
  let showPlaying = false;
  let showStart = true;
  let looping = false;
  let loopStart = 0;
  let loopEnd = 1;
  let time = 0;
  let awaitingLoad = false;

  //settings
  let settings = {
    location: false,
    open: false,
    startPoint: [53.259278, -1.914874],
    locationAvailable: false
  }
  let placeStorage = window.localStorage;
  let showResume = false;
  let showWelcome = true;
  let welcomeMessage = 'Welcome To Raft'

  //Player Methods
  let actions = {
    play: function() {
      audioContext.play()
      audioPlaying = true;
    },
    pause: function() {
      audioContext.pause()
      audioPlaying = false;
      showPlaying = false;
    },
    skip: function(newTime) {
      audioContext.currentTime = newTime;
    },
    loop: function(times) {
      loopStart = times.start
      loopEnd = times.end
      looping = true;
      showPlaying = false;
    },
    breakLoop: function() {
      looping = false;
    },
    updateMap: function(data) {
    //  if (route) {
    //    route.setLatLngs(data.latlngs)
    //    map.fitBounds(route.getBounds());
    //  } else {
        //route =
        let bounds = L.polyline(data.latlngs, {
          color: 'red',
          weight: 5
        }).addTo(map).getBounds()

        map.fitBounds(bounds, { paddingBottomRight: [0,200], animate: true});
      //}
    },
    moveWaypoint: function(data) {
      if (wayPoint) {
        wayPoint.setLatLng([data.lat, data.lng])
      } else {
        wayPoint = L.marker([data.lat, data.lng], {
          icon: wayPointIcon
        }).addTo(map);
      }
      window.navigator.vibrate([200, 100, 200]);
    },
    setTriggerPoint: function(data) {
      triggerPoint = {
        latlng: data.latlng,
        radius: data.radius
      }
      //var circle = L.circle(data.latlng, {
      //  color: '#202020',
      //  fillColor: '#202020',
      //  fillOpacity: 0.3,
      //  radius: data.radius
      //}).addTo(map)
      locationTrigger = true;
    },
    end: function() {
      push('/end');
    }
  }

  onMount(() => {

    var layer = new L.StamenTileLayer("watercolor");
    var labels = new L.StamenTileLayer("terrain-labels")
    map = new L.Map("map", {
      center: new L.LatLng(settings.startPoint[0], settings.startPoint[1]),
      zoom: 16
    });

    map.addLayer(layer);
    map.addLayer(labels);

    geoJSONLayer = L.geoJSON().addTo(map);

    playerMarker = L.circleMarker(([0,0]), {
      color: '#202020',
      fillColor: '#00B6A4',
      fillOpacity: 1,
      radius: 7
    }).addTo(map)

    function activateLocation() {
      settings.location = true;
      map.locate({
        watch: true,
        enableHighAccuracy: true
      });
    }

    activateLocation()

    function onLocationFound(e) {

      if (e.accuracy <= 30) {

        playerMarker.setLatLng(e.latlng)

        if (locationTrigger) {
          if (map.distance(e.latlng, triggerPoint.latlng) < triggerPoint.radius) {
            locationTrigger = false;
            playShow();
          }
        }
        settings.locationAvailable = true
      }
      else {
        settings.locationAvailable = false
      }

    }

    map.on('locationfound', onLocationFound);

    function onLocationError(e) {
      settings.location = false;
    }

    map.on('locationerror', onLocationError);


    document.getElementsByClassName('leaflet-control-attribution')[0].innerHTML =
      '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | <a href="http://stamen.com/">Stamen Design</a> | <a href="http://openstreetmap.org/">OpenStreetMap</a>';


    audioContext = document.getElementById('player')

    if (placeStorage.getItem('savedTime')) {
      showResume = true;
    }

    let saveTimer
    audioContext.addEventListener('playing', function() {
      saveTimer = window.setInterval(function() {
        if (!looping) {
          placeStorage.setItem('savedTime', audioContext.currentTime);
        }
        }, 5000);
    })
    //audioContext.addEventListener('loadstart', function() {
    //  awaitingLoad = true;
    //})
    //audioContext.addEventListener('canplay', function() {
    //  awaitingLoad = false;
    //})
    audioContext.addEventListener('ended', function() {
      window.clearInterval(saveTimer);
    })

    audioContext.addEventListener('timeupdate', function() {
      time = audioContext.currentTime
      if (looping) {
        if (time >= loopEnd) {
          audioContext.currentTime = loopStart
          console.log("looped!");
        }
      }
    })
    audioContext.textTracks[0].mode = 'hidden';
    audioContext.textTracks[0].addEventListener('cuechange', function() {
      if (audioContext.textTracks[0].activeCues[0]) {

        let cue = JSON.parse(audioContext.textTracks[0].activeCues[0].text); // array of current cues

        if (audioPlaying || showStart) {
          messageData = cue
        }

        if (cue.actions) {
          cue.actions.forEach((action, i) => {
            actions[action.type](action);
          });
        }
      }
    })

  })


  function playShow() {
    if (!audioPlaying) {
      audioContext.play()
      audioPlaying = true;
      showPlaying = true;
      if (showStart) {
        showStart = !showStart
      }
    } else if (audioPlaying && looping) {
      actions.breakLoop();
      if (locationTrigger) {
        locationTrigger = false;
      }
      audioContext.currentTime = loopEnd;
      showPlaying = true;
    } else {
      audioContext.pause()
      audioPlaying = false;
      showPlaying = false;
    }
  }


  function handlePlaybar(e) {
    switch (e.detail) {
      case 'play':
        playShow();
        break;
      case 'back':
        if (audioContext.currentTime - 10 >= 0) {
          audioContext.currentTime = audioContext.currentTime - 10;
        }
        break;
      case 'forward':
        if (audioContext.currentTime + 10 <= audioContext.duration) {
          audioContext.currentTime = audioContext.currentTime + 10;
        }
        break;
      default:
        break;
    }
  }

  function handleSave(e) {
    if (e.detail === 'resume') {
      audioContext.currentTime = placeStorage.getItem('savedTime')
    }
    showResume = false;
  }


  function toggleSettings(e) {
    settings.open = !settings.open;
  }
</script>


<video id="player" width="0" height="0" playsinline webkit-playsinline>
  <source src="assets/{params.id}.mp3" type="audio/mp3">
  <track label="English" kind="subtitles" srclang="en" src="assets/{params.id}.vtt" default>
</video>
<div class="settings">
  <Settings open={settings.open} on:pressed={toggleSettings} />
</div>
{#if !settings.locationAvailable && (messageData.type === "start" || messageData.type === "heading")}
<LocationModal />
{/if}
{#if settings.open}
<SettingsModal {...settings}/>
{/if}
{#if showResume}
<ResumeModal on:selected={handleSave}/>
{/if}
{#if showWelcome}
<WelcomeModal on:next={() => showWelcome = false }/>
{/if}
<div in:fade="{{ delay:250, duration: 200 }}" id="map"></div>
<div in:fly="{{ delay:350, y: 50, duration: 200 }}" class="notification-holder">
  <div class="playbar">
    <Playbar playing={showPlaying} on:pressed={handlePlaybar} />
  </div>
  <Timeline {time} duration="1910.725" />
  <div class="notification card">
    <Message {messageData} loading={awaitingLoad} location = {settings.location}/>
  </div>
</div>


<style>
  #map {
    height: calc(100% - 174px);
    width: 100vw;
  }

  .notification-holder {
    position: absolute;
    z-index: 1000;
    bottom: 0px;
    width: 100vw;
  }

  .notification {
    max-width: 100vw;
    height: 130px;
    margin: 0;
  }

  .playbar {
    margin: 20px auto;
    width: 160px;
    height: 60px;
    text-align: center;
  }

  #player {
    display: none;
  }

  .settings {
    position: absolute;
    z-index: 1200;
    top: 20px;
    right: 20px;
  }
</style>
